module.exports = __webpack_public_path__ + "./img/bg.27237739.png";